<template>
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="用户ID"><el-input size="small" v-model="searchForm.user_id" clearable placeholder="请输入用户id"></el-input></el-form-item>
        <el-form-item label="用户手机号"><el-input size="small" v-model="searchForm.phone" clearable placeholder="请输入用户手机号"></el-input></el-form-item>
          <el-form-item label="审核状态">
            <el-select size="small" v-model="searchForm.status" clearable placeholder="请选择" >
              <el-option label="全部" value="-1"></el-option>
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="已通过" :value="1"></el-option>
              <el-option label="未通过" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getTableList">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" border ref="dragTable" v-loading="loading">
        <el-table-column prop="diary.title" label="分享"></el-table-column>
        <el-table-column prop="nickName" label="用户" width="300">
          <template slot-scope="scope" v-if="scope.row.user">
            <div class="d-s-c">
              <img v-img-url="scope.row.user.avatarUrl" width="60px" height="60px" />
              <div class="ml10">
                <p>用户ID：{{scope.row.user.user_id}}</p>
                <p>昵称：{{scope.row.user.nickName}}</p>
                <p v-if="scope.row.user.mobile">手机：{{scope.row.user.mobile}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="评论内容"></el-table-column>
       
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <div class="d-s-c">
               <el-tag v-if="scope.row.status == 0" >待审核</el-tag>
              <el-tag v-if="scope.row.status == 1" type="success" class="green">已通过</el-tag>
              <el-tag v-if="scope.row.status == 2" type="info" class="green">已拒绝</el-tag>
            </div>
            <div  v-if="scope.row.status == 2">
              {{scope.row.reject_reason}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
        <el-table-column fixed="right" prop="name" label="操作" width="140">
          <template slot-scope="scope">
           
            <el-button  v-if="scope.row.status == 0" @click="editClick(scope.row)" type="text" size="small">
                  审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回</el-button>
    </div>
    <commentEdit v-if="open_edit" :open_edit="open_edit" :form="dataModel" @closeDialog="closeDialogFunc($event, 'edit')"></commentEdit>
  </div>
</template>

<script>
import DiaryApi from '@/api/diary.js';
import commentEdit from './dialog/commentEdit.vue';
import qs from 'qs';
export default {
  components: {
    commentEdit
  },
  data() {
    return {
      /*搜索参数*/
      searchForm: {
        user_id: '',
        phone: '',
        diary_id: ''
      },
      /*表单数据*/
      tableData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      dataModel: {}
    };
  },
  created() {
    this.searchForm.diary_id = this.$route.query.diary_id;
    /*获取活动列表*/
    this.getTableList();
  },
  methods: {
   
    /*获取活动列表*/
    getTableList() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      DiaryApi.commentData(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getTableList();
    },

    /*取消添加，返回文章列表*/
    cancelFunc() {
      this.$router.push({
        path: '/diary/diary/index'
      });
    },
    /*打开弹出层编辑*/
    editClick(item) {
      this.dataModel = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/diary/diary/comment.vue